import type { TypePolicies } from '@apollo/client';

export const RESQ_PLUS_CACHE_POLICIES: TypePolicies = {
    ResqPlusAcquisitionType: {
        merge(existing, incoming, { mergeObjects }) {
            // Preserve the offer for eligibility-only reads. Full offers must replace
            // it so omitted source-specific trades become incomplete and refetch.
            return Object.hasOwn(incoming, 'sourceFacility')
                ? incoming
                : mergeObjects(existing, incoming);
        },
    },
};
